import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ReactLenis, useLenis } from "lenis/react";

import { LangProvider } from "./context/LangContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppCTA from "./components/WhatsAppCTA";
import { ROUTES } from "./lib/routes";

import Home from "./pages/Home";
import Treatments from "./pages/Treatments";
import YachtServices from "./pages/YachtServices";
import VillaConciergerie from "./pages/VillaConciergerie";
import XPTherapy from "./pages/XPTherapy";
import Exomobil from "./pages/Exomobil";
import Booking from "./pages/Booking";
import Partners from "./pages/Partners";
import Investors from "./pages/Investors";
import InvestorMode from "./pages/InvestorMode";
import Admin from "./pages/Admin";
import PassCheck from "./pages/PassCheck";

const PAGES = {
  home: Home,
  treatments: Treatments,
  yacht: YachtServices,
  villa: VillaConciergerie,
  xpTherapy: XPTherapy,
  exomobil: Exomobil,
  booking: Booking,
  partners: Partners,
  investors: Investors,
  investorMode: InvestorMode,
  admin: Admin,
};

// Scroll to top on every page change (Lenis-aware, instant)
function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true, force: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
}

function App() {
  // Build the route list dynamically. Each page is registered for both FR & EN paths.
  const routeEntries = Object.entries(ROUTES).flatMap(([key, paths]) => {
    const Component = PAGES[key];
    if (!Component) return [];
    const unique = Array.from(new Set([paths.fr, paths.en]));
    return unique.map((p) => ({ key: `${key}-${p}`, path: p, Component }));
  });

  return (
    <LangProvider>
      <ReactLenis root options={{ lerp: 0.09, duration: 1.15, smoothWheel: true }}>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Navbar />
            <Routes>
              {routeEntries.map(({ key, path, Component }) => (
                <Route key={key} path={path} element={<Component />} />
              ))}
              <Route path="/pass/:code" element={<PassCheck />} />
            </Routes>
            <Footer />
            <WhatsAppCTA />
            <Toaster theme="light" position="bottom-left" toastOptions={{ style: { background: "#FFFFFF", border: "1px solid #E2DBC9", color: "#1A1A20" } }} />
          </BrowserRouter>
        </div>
      </ReactLenis>
    </LangProvider>
  );
}

export default App;
